const Cookies = {
    set(name, value, days) {
        let expires;
        if (name) {
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = `; expires=${date.toGMTString()}`;
            } else {
                expires = '';
            }
            document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
        }
    },
    setShort(name, value, seconds) {
        let expires;
        if (name) {
            if (seconds) {
                const date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = `; expires=${date.toGMTString()}`;
            } else {
                expires = '';
            }
            document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
        }
    },
    setShortMinutes(name, value, minutes) {
        let expires;
        if (name) {
            if (minutes) {
                const date = new Date();
                date.setTime(date.getTime() + minutes * 60 * 1000);
                expires = `; expires=${date.toGMTString()}`;
            } else {
                expires = '';
            }
            document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
        }
    },
    get(name) {
        if (name) {
            const match = document.cookie.match(new RegExp(`${name}=(.*?)(?:;|$)`));
            if (match) {
                try {
                    return decodeURIComponent(match[1]).replace(/\+/g, ' ');
                } catch (e) {
                    return unescape(match[1].replace(/\+/g, '%20'));
                }
            }
        }
    },

    list() {
        const pairs = document.cookie.split(new RegExp('; '));
        if (pairs.length > 0 && pairs[0] !== '') {
            const keys = new Array(pairs.length);
            for (let i = 0; i < pairs.length; i++) {
                keys[i] = pairs[i].match(/(.+?)=/)[1];
            }
            return keys;
        }
        return [];
    },

    // delete is a reserved word, so appending an underscore
    del(name) {
        this.set(name, '', -1);
    }
};
export default Cookies;
